import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function WhoThisIsFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forWho = ['Padres inmigrantes con hijos nacidos en USA que sienten que la cultura los está separando.', 'Familias que han notado cambios negativos en la conducta o el lenguaje de sus hijos adolescentes.', 'Padres que temen que sus hijos caigan en drogas, alcohol o retos peligrosos por presión de grupo.', 'Valientes que quieren dejar de gritar y empezar a guiar con estrategia.'];
  const notForWho = ['Padres que buscan una solución mágica sin involucrarse en la conversación.', 'Personas que creen que la única forma de criar es a través del miedo físico o la dominación total.', 'Aquellos que no están dispuestos a entender la realidad digital en la que viven sus hijos hoy.'];
  return <section ref={ref} className="w-full bg-dark-navy py-16 md:py-20 px-6" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-131">
          <div className="grid md:grid-cols-2 gap-10" data-id="element-132">
            <div data-id="element-133">
              <h2 className="text-3xl md:text-4xl font-oswald text-gold mb-8" data-id="element-134">
                Esta Guía Es Para Ti Si...
              </h2>
              <div className="space-y-4" data-id="element-135">
                {forWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: -20
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex gap-3 items-start" data-id="element-136">
                    <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-137" />
                    <p className="text-gray-300 leading-relaxed" data-id="element-138">{item}</p>
                  </motion.div>)}
              </div>
            </div>

            <div data-id="element-139">
              <h2 className="text-3xl md:text-4xl font-oswald text-gold mb-8" data-id="element-140">
                Esta Guía NO Es Para Ti Si...
              </h2>
              <div className="space-y-4" data-id="element-141">
                {notForWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: 20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: 20
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex gap-3 items-start" data-id="element-142">
                    <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-143" />
                    <p className="text-gray-300 leading-relaxed" data-id="element-144">{item}</p>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}